module.exports = __webpack_public_path__ + "static/img/pro-1-220x294.b05f305.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pro-1-220x294.jpg
// module id = W3SS
// module chunks = 1